/**
 * 제품 화면에서만 사용하는 폴링 간격(ms).
 * 대시보드·모니터링 latest 외 쿼리에는 refetchInterval을 두지 않는다.
 */

/** GET monitoring/latest — 지도·디바이스 리스트 실시간 */
export const POLL_MONITORING_LATEST_MS = 5_000;

/** GET dashboard/live-aggregation */
export const POLL_DASHBOARD_LIVE_MS = 5_000;

/** GET dashboard/alarm-history (백엔드 Redis ~1분) */
export const POLL_DASHBOARD_ALARM_HISTORY_MS = 60_000;

export const STALE_DASHBOARD_ALARM_HISTORY_MS = 50_000;

/** GET monitoring/push-history — Push Alarm 리스트 갱신 */
export const POLL_PUSH_HISTORY_MS = 30_000;

/** GET dashboard/static (백엔드 Redis ~5분) */
export const POLL_DASHBOARD_STATIC_MS = 5 * 60_000;

export const STALE_DASHBOARD_STATIC_MS = 4 * 60_000;
